import MobileTitleBar from "components/MobileTitleBar"
import OrderTable from "components/OrderTable/OrderTable"
import Price from "components/Price/Price"
import Badge from "components/Product/Badge"
import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductImages from "components/Product/ProductImages"
import ProductPrice from "components/Product/ProductPrice"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductPath from "components/ProductPath"
import Variants from "components/Variants/Variants"
import {Col, Row} from "elemental-react16"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React, {Component, useEffect, useRef,Fragment} from "react"
import Responsive from "react-responsive"
import {Link, Route, Switch, useLocation} from "react-router-dom"
import ButtonLove                                                                     from "components/Button/ButtonLove";
import {Breadcrumb, Button, Card, Container, Icon, Input, Loader, Message, Modal, Select, Table, Image,Label} from "semantic-ui-react"
import { ProductDownloads }                                                           from "components/ProductDownloads";
import Collapsible                                                                    from 'react-collapsible';
import htmr                                                                           from "htmr";
import shop from "shop/shop"
import MinOrderValue from "components/Cart/MinOrderValue"
import MinOrderFreeValue from "components/Cart/MinOrderFreeValue"
import productStore from "stores/productStore"
import settingStore from "stores/settingStore"
import "style/ProductPage.scss"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import ProductSearch                                                                  from "components/Product/ProductSearch"
import ProductSearchExtra                                                             from "components/Product/ProductSearchExtra"
import ProductCard                                                                    from "components/Product/ProductCard"
import ProductList                                                                    from "components/Product/ProductList"
import CustomFields                                                                   from "components/CustomFields/CustomFields"
import CartTotalMinimum                                          from "components/Cart/CartTotalMinimum"
import { trackAddToCart } from "components/tracking/Tracking";
import WordPressShopComponent                                                         from "../../../components/WordPressShopComponent/WordPressShopComponent";

let lastProducts = null

const ProductAction = ( {product, onAdd} ) => {
	const [count, setCount] = React.useState( product.count )
	const list = shop.orderlist.default
	if ( !product ) return <div>Ungültiges Produkt</div>
	const veOptions = product.quantities.map( q => {
		return (
			{
				key  : q.map_desc_id,
				text : `${q.des} (${q.multi})`,
				value: q.map_desc_id
			}
		)
	} )
	return (
		<div className="ProductAction">

			{product &&
			<Input type="number" step={product.unit_multi} min={0} placeholder="1" value={count || ""} action
				   onBlur={(e => {
					   let ok = product.validateCount( e.currentTarget.value )
					   let value = e.currentTarget.value
					   let nearestValidCount = Math.round( value / product.unit_multi ) * product.unit_multi
					   if ( ok ) {
						   setCount( nearestValidCount )
					   }
				   })}
				   onChange={e => {
					   let ok = product.validateCount( e.currentTarget.value )
					   if ( ok ) setCount( e.currentTarget.value )
				   }
				   }>
				<input />
				<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
						onChange={( e, data ) => {
							const {value} = data
							const ve = product.quantities.filter( q => q.map_desc_id === value )
							if ( !ve ) return
							product.unit_multi = ve[0].multi
							product.unit_id = ve[0].map_desc_id
							console.log( {data, e, value: e.target.value, target: e.target} )
						}
						}
				/>
				<Button color={"black"} icon={"shopping cart"} onClick={() => {
					let nearestValidCount = Math.round( count / product.unit_multi )
					product.count = nearestValidCount

					console.info( "BUY", nearestValidCount, product.unit_multi, product.unit_id )
					onAdd( {product} )
				}
				} />
			</Input>
			}

		</div>
	)
}


export class OrderTableContainer extends Component {

	state = {
		byAttribute: false
	}

	componentDidMount() {
		const {product} = this.props
		console.log("this.props: ",this.props)
		if ( !product ) return

		productStore.partlist( product.mainart , true)
			.then( variants => {
				if ( !variants ) {
					console.error( "Keine Varianten gefunden ", {product} )
					return
				}
				console.log("variants: ", {variants} )
				const variantProtoypeByKey = {}

				let byAttribute = {}
				let variantMap = {}
				variants.variants.varfields.forEach( varfield => {

					let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
					var ordered = {};
					// TODO: UNIFY
					_( categories ).keys().sort(
						( a, b ) => {
							let s0 = ordinals[a]
							let s1 = ordinals[b]
							return s0 >= s1 ? 1 : -1
						}
					).each( function ( key ) {
						ordered[key] = categories[key];
					} );
					byAttribute[varfield] = ordered
				} )

				let count = 0
				variants.products.forEach( product => {
					if ( !product.available ) return
					count++
					const hash = variants.variants.varfields
						.map( varfield => {
							const bucket = variantProtoypeByKey[varfield] || {}
							if ( !bucket[product.extraValue[varfield]] ) {
								bucket[product.extraValue[varfield]] = product
							}
							variantProtoypeByKey[varfield] = bucket

							return product.extraValue[varfield] || "null"
						} )
						.join( "___" )

					variantMap[hash] = product
				} )

				console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
				this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
			} )
	}

	render() {
		const {product} = this.props
		const {byAttribute, variantProtoypeByKey, variantMap} = this.state
		return <div className={"OrderTableContainer cf"}>
			{shop.config.plugin.showVariantsTable && byAttribute && <OrderTable style={{zIndex: 120}} isToggle={this.props.isToggle} product={product} byAttribute={byAttribute}
										variantProtoypeByKey={variantProtoypeByKey}
										variantMap={variantMap} />}

		</div>
	}
}


export default class ProductPage extends Component {

	componentWillUnmount() {
		document.body.classList.remove( "no-scroll" )
		console.log("ProductPage::componentWillUnmount")
	}

	constructor( props ) {
		const {match} = props
		super()
		this.state = {
			showOrderTable   : shop.isToggle || false,
			id               : match.params.productId,
			product          : {},
			fullscreenElement: null,
			variants         : false,
			dangerItem: false,
			showMinOrderValue: false,
			showCalc: true,
			activeIndex: 1,
			defActiveIndex: 0,
			handUserPriceTemp: false,
			showCartTotalMinimum: false
		}
	}

	toggleModal = () => {
		this.setState( {showOrderTable: !this.state.showOrderTable} )
	}

	loadProduct( id ) {
		if ( this.id === id ) return
		this.id = id
		this.setState( { product: {} } )
		productStore.get( id )
			.then( product => {
				console.log( "ProductPage::product", product )
				product.count = 1
				let inCart = shop.cart.productsById.get( product.map_id )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				 lastProducts = shop.analytics.lastProducts( 4 )
				  .filter( ( id ) => id !== product.map_id )
				this.setState( {product: product, primaryImage: false} )

				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						//console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}

	add = ( { product } ) => {
		//if ( product.count === 0 ) return shop.cart.remove( product )
		console.log("product ADD",product)
		if(shop.session.handUser && shop.session.handUser.costManager){
			//console.log("Kommen wir hier rein?")
		  product.extras.customPrice = product.price;
		}
		console.log("product ADD",product)
		let ok = shop.cart.add( product )
		
		//console.log("setExtra handuser",shop.session)
		if(shop.session.handUser && shop.session.handUser.costManager){
		  //console.log("product setExtra",product,product.price)
		  shop.cart.setExtraPositions(product, "customPrice", product.price);
		}
		//shop.cart.setExtraPositions(product, "basePrice", product.price);
		console.log("ok",ok)
		console.log(shop.whoami())
		shop.toast( `${product.count * product.unit_multi} ${translate("Stück")} ${product.title} ${translate( "im Warenkorb" )}`, "neutral", false, "bottom" )
		this.setState( { showMinOrderValue: true } )
	  }

	/*add = ( {product} ) => {
		console.log("setExtra handuser",shop.session)
		if(shop.session.handUser && shop.session.handUser.costManager){
			shop.cart.setExtraPositions(product, "customPrice", product.price);
		  }
		let ok = product.validateCount( product.count )
		if ( ok ) {
			if( ok ) this.setState( { showMinOrderValue: true } )
			shop.toast( translate( `toast.CART_ADD`, {total: product.unit_multi * product.count, title: product.title} ), "info", false, "top" )
			return shop.cart.add( product )
		} else {
			shop.toast( `<div>
<div>${translate( "Maximale Abnahmemenge erreicht" )}</div>
<div class="f6 ttu">${translate( "personalized_max_order_message", {value: product.stock} )}</div>
</div>`, "warning", false, "top" )
		}

	}*/

	updateProduct = ( {product} ) => {
		this.setState( {product} )
	}

	componentWillReceiveProps( {match} ) {
		let {productId} = match.params
		this.loadProduct( productId )
	}

	showFullscreen = ( element ) => {
		this.setState( {
			fullscreenElement: element
		} )
	}

	setPrimaryImage = ( primaryImage ) => {
		this.setState( {primaryImage} )
	}

	componentDidMount() {
		this.loadProduct( this.state.id )
	}


	render() {
		let {showOrderTable, fullscreenElement, product, byAttribute, variantMap, primaryImage, variantProtoypeByKey, dangerItem, showMinOrderValue, handUserPriceTemp, showCartTotalMinimum} = this.state

		let {sum, loading} = shop.cart
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
        const MIN_ORDER_FREE_VALUE = Number( shop.config.MIN_ORDER_FREE_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (sum > shop.config.MIN_ORDER_VALUE)
		let aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || (sum > shop.config.MIN_ORDER_FREE_VALUE)
		let shippingCosts = sum <= 100 ? "9,95" : (sum >= 150 ? "0,00" : "7,95");
		if(shop.session && shop.session.shopuser){
			aboveMinFree = !shop.config.MIN_ORDER_FREE_VALUE || 
			(sum >= shop.config.MIN_ORDER_FREE_VALUE) || 
			(shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.extras && 
			 (shop.cart.data.deliveraddress.extras.lieferart == "EL" || 
			  shop.cart.data.deliveraddress.extras.lieferart == "Abholung")) || 
			(Object.keys(shop.cart.data.deliveraddress).length === 0 && shop.session.value && shop.session.value.extras && 
			 (shop.session.value.extras.lieferart == "EL" || 
			  shop.session.value.extras.lieferart == "Abholung"));
		}
		let additionalProds = []
		if(product.extras && product.extras.Zubehör && product.extras.Zubehör.value.value !== ""){
			additionalProds = product.extras.Zubehör.value.value.replaceAll('[','').replaceAll(']','').replaceAll('"','').split(',')
			
		}

		let additionalCustProds = []
		if(product.extras && product.extras.Empfehlung && product.extras.Empfehlung.value.value !== ""){
			additionalCustProds = product.extras.Empfehlung.value.value.replaceAll('[','').replaceAll(']','').replaceAll('"','').split(',')
			console.log("additionalCustProds",additionalCustProds)
		}

		if(dangerItem === false && product.extras && product.extras.gefahrgut_kuerzel0 && product.extras.gefahrgut_kuerzel0.value.value !== ""){
			dangerItem = true

		}

		if ( !product._type ) return null //  duck type check for ProductModel
		let img_srcs = product.img_srcs

		let chooseCat = document.location ? document.location.search ? document.location.search.substring(document.location.search.length - 5, document.location.search.length - 1) : "" : ""

		let category = {}
		if (chooseCat) {
			for (let i = 0; i < product.cats.length; i++) {
				if (product.cats[i].cat_id == chooseCat) {
					category = product.cats[i];
					break;
				}
			}
		}
		else{
			category = product.cats[0] && product.cats[0] || {}
		}
		let cat_id = category.cat_id

		let productImage = false

		if ( product.img_src ) {
			productImage = product.img_src_large
		}

		if ( primaryImage ) productImage = primaryImage
		let categoryName = shop.categoryName(product.cats[0] ? product.cats[0].cat_id : null)
		// let categoryName = shop.categoryName(product.cats[0].cat_id)
		let path = shop.getCategoryPath( cat_id )
		const {history} = this.props

		path.push( {
			title: product.title,
			link : ""
		} )

		// const veOptions = [
		//   { key: 'all', text: 'All', value: 'all' },
		//   { key: 'articles', text: 'Articles', value: 'articles' },
		//   { key: 'products', text: 'Products', value: 'products' },
		// ]


		const poison = [
			{key: 'H300', text: 'H300', value: 'H300'},
			{key: 'H301', text: 'H301', value: 'H301'},
			{key: 'H310', text: 'H310', value: 'H310'},
			{key: 'H311', text: 'H311', value: 'H311'},
			{key: 'H330', text: 'H330', value: 'H330'},
			{key: 'H331', text: 'H331', value: 'H331'},
			{key: 'H300+H310', text: 'H300+H310', value: 'H300+H310'},
			{key: 'H300+H330', text: 'H300+H330', value: 'H300+H330'},
			{key: 'H310+H330', text: 'H310+H330', value: 'H310+H330'},
			{key: 'H300+H310+H330', text: 'H300+H310+H330', value: 'H300+H310+H330'},
			{key: 'H301+H311', text: 'H301+H311', value: 'H301+H311'},
			{key: 'H301+H331', text: 'H301+H331', value: 'H301+H331'},
			{key: 'H311+H331', text: 'H311+H331', value: 'H311+H331'},
			{key: 'H301+H311+H331', text: 'H301+H311+H331', value: 'H301+H311+H331'}
		]

		const acidCorrosion = [
			{key: 'H290', text: 'H290', value: 'H290'},
			{key: 'H314', text: 'H314', value: 'H314'},
			{key: 'H318', text: 'H318', value: 'H318'},
		]

		const oxidizing = [
			{key: 'H270', text: 'H270', value: 'H270'},
			{key: 'H271', text: 'H271', value: 'H271'},
			{key: 'H272', text: 'H272', value: 'H272'},
		]

		const flamable = [
			{key: 'H206', text: 'H206', value: 'H206'},
			{key: 'H207', text: 'H207', value: 'H207'},
			{key: 'H208', text: 'H208', value: 'H208'},
			{key: 'H220', text: 'H220', value: 'H220'},
			{key: 'H221', text: 'H221', value: 'H221'},
			{key: 'H222', text: 'H222', value: 'H222'},
			{key: 'H223', text: 'H223', value: 'H223'},
			{key: 'H224', text: 'H224', value: 'H224'},
			{key: 'H225', text: 'H225', value: 'H225'},
			{key: 'H226', text: 'H226', value: 'H226'},
			{key: 'H227', text: 'H227', value: 'H227'},
			{key: 'H228', text: 'H228', value: 'H228'},
			{key: 'H229', text: 'H229', value: 'H229'},
			{key: 'H230', text: 'H230', value: 'H230'},
			{key: 'H232', text: 'H232', value: 'H232'},
			{key: 'H242', text: 'H242', value: 'H242'},
			{key: 'H250', text: 'H250', value: 'H250'},
			{key: 'H251', text: 'H251', value: 'H251'},
			{key: 'H252', text: 'H252', value: 'H252'},
			{key: 'H260', text: 'H260', value: 'H260'},
			{key: 'H261', text: 'H261', value: 'H261'},
			{key: 'H241', text: 'H241', value: 'H241'},
			{key: 'H282', text: 'H282', value: 'H282'},
			{key: 'H283', text: 'H283', value: 'H283'}
		]

		const extremeHealthHazard = [
			{key: 'H304', text: 'H304', value: 'H304'},
			{key: 'H305', text: 'H305', value: 'H305'},
			{key: 'H334', text: 'H334', value: 'H334'},
			{key: 'H340', text: 'H340', value: 'H340'},
			{key: 'H341', text: 'H341', value: 'H341'},
			{key: 'H350', text: 'H350', value: 'H350'},
			{key: 'H350i', text: 'H350i', value: 'H350i'},
			{key: 'H351', text: 'H351', value: 'H351'},
			{key: 'H360', text: 'H360', value: 'H360'},
			{key: 'H360F', text: 'H360F', value: 'H360F'},
			{key: 'H360D', text: 'H360D', value: 'H360D'},
			{key: 'H360FD', text: 'H360FD', value: 'H360FD'},
			{key: 'H360Fd', text: 'H360Fd', value: 'H360Fd'},
			{key: 'H360Df', text: 'H360Df', value: 'H360Df'},
			{key: 'H361', text: 'H361', value: 'H361'},
			{key: 'H361f', text: 'H361f', value: 'H361f'},
			{key: 'H361d', text: 'H361d', value: 'H361d'},
			{key: 'H361fd', text: 'H361fd', value: 'H361fd'},
			{key: 'H362', text: 'H362', value: 'H362'},
			{key: 'H370', text: 'H370', value: 'H370'},
			{key: 'H371', text: 'H371', value: 'H371'},
			{key: 'H372', text: 'H372', value: 'H372'},
			{key: 'H373', text: 'H373', value: 'H373'}
		]

		const explosive = [
			{key: 'H200', text: 'H200', value: 'H200'},
			{key: 'H201', text: 'H201', value: 'H201'},
			{key: 'H202', text: 'H202', value: 'H202'},
			{key: 'H203', text: 'H203', value: 'H203'},
			{key: 'H209', text: 'H209', value: 'H209'},
			{key: 'H210', text: 'H210', value: 'H210'},
			{key: 'H211', text: 'H211', value: 'H211'},
			{key: 'H231', text: 'H231', value: 'H231'},
			{key: 'H240', text: 'H240', value: 'H240'},
			{key: 'H241', text: 'H241', value: 'H241'},
			{key: 'H204', text: 'H204', value: 'H204'},
			{key: 'H205', text: 'H205', value: 'H205'}
		]

		const gasPressure = [
			{key: 'H280', text: 'H280', value: 'H280'},
			{key: 'H281', text: 'H281', value: 'H281'},
			{key: 'H282', text: 'H282', value: 'H282'},
			{key: 'H283', text: 'H283', value: 'H283'},
			{key: 'H284', text: 'H284', value: 'H284'}
		]

		const healthHazard = [
			{key: 'H302', text: 'H302', value: 'H302'},
			{key: 'H303', text: 'H303', value: 'H303'},
			{key: 'H312', text: 'H312', value: 'H312'},
			{key: 'H313', text: 'H313', value: 'H313'},
			{key: 'H315', text: 'H315', value: 'H315'},
			{key: 'H316', text: 'H316', value: 'H316'},
			{key: 'H317', text: 'H317', value: 'H317'},
			{key: 'H319', text: 'H319', value: 'H319'},
			{key: 'H320', text: 'H320', value: 'H320'},
			{key: 'H332', text: 'H332', value: 'H332'},
			{key: 'H333', text: 'H333', value: 'H333'},
			{key: 'H335', text: 'H335', value: 'H335'},
			{key: 'H336', text: 'H336', value: 'H336'},
			{key: 'H302+H312', text: 'H302+H312', value: 'H302+H312'},
			{key: 'H302+H332', text: 'H302+H332', value: 'H302+H332'},
			{key: 'H312+H332', text: 'H312+H332', value: 'H312+H332'},
			{key: 'H302+H312+H332', text: 'H302+H312+H332', value: 'H302+H312+H332'},
			{key: 'H420', text: 'H420', value: 'H420'},
			{key: 'H204', text: 'H204', value: 'H204'}
		]

		const pollution = [
			{key: 'H400', text: 'H400', value: 'H400'},
			{key: 'H401', text: 'H401', value: 'H401'},
			{key: 'H402', text: 'H402', value: 'H402'},
			{key: 'H410', text: 'H410', value: 'H410'},
			{key: 'H411', text: 'H411', value: 'H411'},
			{key: 'H412', text: 'H412', value: 'H412'},
			{key: 'H413', text: 'H413', value: 'H413'}
		]

		const piktogram = [
			{key: 'H-Satz', text: 'H-Satz', value: 'H-Satz'}
		]

		const veOptions = product.quantities.map( q => {
			return (
			  {
				key: q.map_desc_id,
				text: `${q.des} (${q.multi})`,
				value: q.map_desc_id
			  }
			)
		  } )

		const mode = settingStore.get( "orderMode" )

		const myRef = useRef<HTMLElement | null>(null);

		showCartTotalMinimum && setTimeout(() => {
									if (this.state.showCartTotalMinimum) {
										this.setState({ showCartTotalMinimum: false });
									}
								}, 4000)

		if ( !product.available ) return <Message>
			<div className="tc"> Dieses Produkt ist im Modus {translate( mode )} nicht verfügbar</div>
			{/*<pre>{JSON.stringify( product.extras, null, 2 )}</pre>*/}
		</Message>
		return (
			<div className="bg-white mobileHeaderPadding">

				<MobileTitleBar>
					{console.log("PRODUCTPATH:", path)}
					<ProductPath path={path} title={product.title} product={product} />
				</MobileTitleBar>

				<Container className="relative pt5 ">
					<ProductFullscreen
						change={this.showFullscreen}
						images={img_srcs}
						image={fullscreenElement} />


					{/*<div className="db pt2 pb1 ">
						<Breadcrumb>
							<Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>
							<Breadcrumb.Divider />
							{path.map( segment => {
								console.log("segment",segment)
								if ( !segment.link ) return <Breadcrumb.Section key={segment.title} active
																				style={{whiteSpace: "nowrap"}}>{segment.title}</Breadcrumb.Section>
								return <React.Fragment key={segment.title}>
									<Breadcrumb.Section link as={Link}
														to={segment.link}>{segment.title}</Breadcrumb.Section>
									<Breadcrumb.Divider />
								</React.Fragment>
							} )
							}

						</Breadcrumb>
					</div>*/}


					<Responsive minWidth={790}>
						<div className="db pv3 pt3">
							<ProductPath path={path} title={product.title} product={product} chooseCat={chooseCat} /> <br />
						</div>
					</Responsive>


					{/*<Breadcrumbs path={path}/>*/}
					<section className="product product-single pb6-ns pb5">
						{/*<ProductPath path={path} title={product.title} product={product}/>*/}
						<Row>
						<Col sm="1" md="8/8" lg="5/12" className="relative">
														<div className="absolute right-2 pr3"><Badge product={product} /></div>
														<div className="relative">
															<ProductImages 
																key={product.map_id}
																product={product}
																images={img_srcs}
																image={productImage}
																onClick={this.showFullscreen}
																onClickSecondary={this.setPrimaryImage} />
															<WordPressShopComponent key={`${product.map_id}`} slug={`${product.map_id}-single`} cat_id={product.category.map_id}
																fallback={
																	<WordPressShopComponent key={`${categoryName} ${product.category.map_id}`} slug={`${categoryName} ${product.category.map_id}`} cat_id={product.category.map_id}/>
																}/>
														</div>
													</Col>
							<Col sm="1" md="1/2" lg="1/12"></Col>
							<Col sm="1" md="1/2" lg="6/12">
								{/*showCartTotalMinimum && (
									<div className="left-1/2 -translate-x-1/2 px-4 py-3 rounded-xl text-white bg-gray-800 pointer-events-none animate-slideDownAndFade">
										<CartTotalMinimum located="ProductPage" />
									</div>
								)*/}
								{/* Hide CartTotalMinimum after 10 seconds */}
								<TitleSection product={product} />
								
								{/*{shop.session && <ActionSection product={product}*/}
								{/*onChange={this.updateProduct}*/}
								{/*onAdd={this.add}/>*/}
								{/*}*/}

								{/*{shop.session && <ProductAction product={product}*/}
								{/*                                onAdd={this.add}*/}
								{/*/>}*/}
								<div className="pt3">
								<table >
									<colgroup>
										<col style={{width: "15%"}}/>
										<col style={{width: "20%"}}/>
										<col style={{width: "70%"}}/>
									</colgroup>
									<tbody>
										<tr className="pb5">
											<td  className="tl">{product.getNotice()}</td>
											<td className="tl">{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <ButtonLove list={shop.orderlist.default}
                                      circular={false}
                                      className="f7 black-20"
                                      elementInActive={<div className={"f6 black-40"}><Icon name={"heart"} className=""/> {translate( "Merkliste" )}</div>}
                                      elementActive={<div className={"f6 black-40"}><Icon name={"heart"} className={"red "}/> {translate( "Merkliste" )}</div>}
                                      product={product}/>}</td>
											<td>&nbsp;</td>
										</tr>
										<tr className="pb3 pt3">
											<td  className={shop.session ? "pt4" : "pt4 pr4"}>
												<div style={{width: !shop.session ? "200px" : "auto"}} className="">{shop.session && shop.session.shopuser && !shop.session.shopuser.guest ?<span><ProductPrice className={"f2 pb4 pt3 relative lh-solid"} product={product} /></span> : 
													<Button
													style={{ minWidth: "175px", maxWidth: "175px", height: "60px", borderRadius: "35px", border: "2px solid rgb(221, 218, 218)", backgroundColor: "#ffffff" }}
													as={Link}
														onMouseEnter={(e) => {
															e.target.style.backgroundColor = "#f1f1f1";
															const button = e.currentTarget;
															const svg = e.target.querySelector("svg");
															if (svg) {
																svg.querySelectorAll("path").forEach(path => path.setAttribute("fill", "white"));
															}
															const p = button.querySelector("p");
															if (p) {
																p.style.backgroundColor = "transparent";
															}
															const div = button.querySelector("div");
															if (div) {
																p.style.backgroundColor = "transparent";
															}
														}}
														onMouseLeave={(e) => {
															// Always reset the button background and color
															const button = e.currentTarget;
															button.style.backgroundColor = "#ffffff";
															button.style.color = "black";
															// Reset SVG path colors
															const svg = button.querySelector("svg");
															if (svg) {
																const fills = [
																	"#f1f1f1", "#f1f1f1", "#f1f1f1", "#f1f1f1", "#f1f1f1", "#f1f1f1", "#f1f1f1"
																];
																svg.querySelectorAll("path").forEach((path, i) => path.setAttribute("fill", fills[i] || "#f1f1f1"));
															}
															// Reset <p> color if it was changed
															const p = button.querySelector("p");
															if (p) {
																p.style.color = "black";
																p.style.backgroundColor = "transparent";
															}
															const div = button.querySelector("div");
															if (div) {
																// Reset all <p> inside the div
																const ps = div.querySelectorAll("p");
																ps.forEach(pTag => {
																	pTag.style.color = "black";
																	pTag.style.backgroundColor = "transparent";
																});
																// Reset the div itself
																div.style.color = "black";
																div.style.backgroundColor = "transparent";
															}
														}}
													to={`/login/?referrer=${document.location.pathname}#login`}
													
													rel="noopener noreferrer"
												><p className="tc f6 fw5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
													{translate( "Login für Preise" )}</p>
												</Button>}</div>
											</td>
											<td className="f4 fw7  pt4">
											{
											<div className="">
												<div className="f4 fw7 ">{product.quantities ? product.quantities[0] ? Math.round(product.quantities[0].multi) : "" : "1"}&nbsp;{translate("Stück")}
												</div>
												<div className="pt2 black-30 f6 fw6 lh-solid">{product.extras.veextrainfo || translate( "Pro Verkaufseinheit" )}</div>
											</div>}
											</td>
											<td>&nbsp;</td>
										</tr>
									</tbody>
								</table>
								</div>
								{shop.session && showMinOrderValue && 
                    <div className="pb2 pt2">
        
                    
                </div>}				
				{<div className=" ">

                  
                  {(product && product.canBeBought) && <div>
                    {
                      <div className="product-actions">
						<div  className="pt1 flex flex-row items-start justify-start">
                        {product &&
                          <Input style={{borderRadius: "35px", height: "60px"}} className="transparent ba b--black-20 bw1 pr3 pl3" type="number" min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} placeholder={product.count || 1} 
						  defaultValue={1} 
						  value={this.state.count}
						  action 
						  onChange={e => {
							  this.setState({ count: e.target.value });
						  }}
						  onBlur={e => {
							  if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
								shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
								e.target.value = Number(product.pinfos.minbuy);
								this.setState({ count: e.target.value });
								  
							  }
						  }}>
							<Button style={{borderRadius: "35px", backgroundColor: "#ffffff"}} icon="minus" onClick={() => {
								let newCount = Math.max((this.state.count ||  1) - 1);
								if(newCount < 1){
									newCount = 1

								}
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />
							<input style={{ width: "70px", height: "60px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
							{/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
									onChange={( e, data ) => {
									  const { value } = data
									  const ve = product.quantities.filter( q => q.map_desc_id === value )
									  if ( !ve ) return
									  product.unit_multi = ve[ 0 ].multi
									  product.unit_id = ve[ 0 ].map_desc_id
									  console.log( { data, e, value: e.target.value, target: e.target } )
									}
									}
							/>*/}

							<Button style={{borderRadius: "35px", backgroundColor: "#ffffff" }} className="mr2" icon="plus" onClick={() => {
								let newCount = (this.state.count ||  1) + 1;
								console.log("newCount",newCount)
								this.setState({ count: newCount });
							}} />


                          </Input>
                        }
						<div className="pl2 pr2"></div>
												{shop.session && <Button primary style={{borderRadius: "35px", height: "60px", width: "250px"}} className="ml3 pl3"  onClick={() => {
							product.count = Math.max(this.state.count || 1, product.pinfos.minbuy || 1)
							product.price = product.pinfos.priceTemp ? product.pinfos.priceTemp : product.price
                            console.info( "BUY", this.state.count, product.unit_multi, product.unit_id )
                            this.add( { product } )
							this.setState({ showCartTotalMinimum: true })
							trackAddToCart(product.map_id, product.title)
							shop.whoami()
                          }
                          }>
                            <div className="ph3 ph4-ns flex flex-row items-center justify-center">
                              <Icon name={"shopping cart"}/>&nbsp; {translate("In den Warenkorb")}
                            </div>
                          </Button>}
						</div>
						{shop.config.plugin.showVariantsTable && byAttribute && product.mainart && product.extras && product.extras.attr2 && product.extras.attr2.value.value !== "" && <div className="pl2 pr5 flex flex-row items-start justify-start">
													{byAttribute && <a className="black-50 fw6" onClick={() => {
										const element = document.getElementById('my-section');
										if ( !element ) return;
										window.scroll({
											top: element.offsetTop - 20,
											behavior: 'smooth'
										}) 
										}}>
										{translate("Varianten im Überblick")} →
										</a>}
							</div>}
                        {shop.session && <div className="pt2 pr5 flex flex-row items-center justify-center">

						{byAttribute && product.mainart && product.extras && product.extras.attr2 && product.extras.attr2.value.value !== "" && <a className="black-50 fw6" onClick={() => {
										const element = document.getElementById('my-section');
										if ( !element ) return;
										window.scroll({
											top: element.offsetTop - 20,
											behavior: 'smooth'
										}) 
										}}>
										{translate("Varianten im Überblick")} →
										</a>}
						  {/*shop.session && <div>
									{ eslint-disable-next-line react/jsx-no-undef }
									{product.mainart && <Button primary onClick={this.toggleModal} fluid><Icon name={"shopping cart"} /> {translate( "Varianten wählen" )}</Button>}
									{!product.mainart && <ProductAction product={product}
																		onAdd={this.add}
									/>}
								</div>*/}
																	{/*!shop.session && 
										<a className="pl2" style={{color:"#0e418b"}}><b>{translate("Wenn sie noch nicht registriert sind, können Sie sich über unseren Warenkorb ein Angebot einholen.")}<br/>
										{translate("Einfach Artikel in den Warenkorb legen und Anfrage abschicken.")}</b><br/><br/></a>}
									{shop.session && shop.session.shopuser && shop.session.shopuser.guest && 
										<a  className="pl2" style={{color:"#0e418b"}}><b><br/>{translate("Wenn sie noch nicht registriert sind, können Sie sich über unseren Warenkorb ein Angebot einholen.")}<br/>
										{translate("Einfach Artikel in den Warenkorb legen und Anfrage abschicken.")}</b><br/><br/></a>*/}

                        </div>}
                      </div>}

                  </div>}
                </div>}
								{shop.session && shop.session.shopuser && !shop.session.shopuser.guest  && <BulkPricing product={product} />}


								{!shop.session && <div>
									{/*<p>
										{translate( "shop.please_login_for_product_details" )}
									</p>*/}

									<div className="productPageLoginButtons">
										
												<Button
													style={{ minWidth: "300px", height: "60px", borderRadius: "35px" }}
													as={Link}
													to={`/login/?referrer=${document.location.pathname}login`}
													primary
													rel="noopener noreferrer"
												><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
													<Icon className="mb2" name={"large  power off"}/>{translate( "Bestandskunden: Anmelden" )}</p>
												</Button>
											<Button
											style={{ minWidth: "300px", height: "60px", borderRadius: "35px" }}
											as={Link}
											to={`/login/?referrer=${document.location.pathname}register`}
											primary
											target="_blank"
											rel="noopener noreferrer"
											>
											<p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}><Icon className="mb2" name={"large file text"}/>{translate( "Neukunden: Registrieren" )}</p>
											</Button>
									</div>
								</div>}
								<div className="pt5"></div>
							<Responsive maxWidth={789} ><div className="pt2">&nbsp;</div></Responsive>
							<Collapsible tabIndex={0} open={true} trigger={translate( "Produktbeschreibung" )}>
							<p className="pr3 pl3">
							<DescriptionSection product={product}/>
								
								</p>
								</Collapsible>
							<Collapsible tabIndex={0} open={true} trigger={translate( "Produktdetails" )}>
							<p className="pr3 pl3">
									{<TechnicalTable  product={product} />}
									</p>
									</Collapsible>
									{product.extras && product.extras.gefahrgut_kuerzel0 && product.extras.gefahrgut_kuerzel0.value && 
										<Collapsible tabIndex={0} open={dangerItem} trigger={translate( "Gefahrenhinweise" )}>
									<p className="pr3 pl3">
									<DangerSection className="" poison={poison} 
												acidCorrosion={acidCorrosion} 
												oxidizing={oxidizing}
												flamable={flamable}
												extremeHealthHazard={extremeHealthHazard}
												explosive={explosive}
												gasPressure={gasPressure}
												healthHazard={healthHazard}
												pollution={pollution}
												product={product} />
												</p>
									</Collapsible>}
									{
										<ProductDownloads product={product}/>
									}
							</Col>
						</Row>
						{/*						<Row>
							<Col className="" sm="1" md="1/2" lg="7/16" relative>

							</Col>
							<Col  sm="1" md="1/2" lg="1/16" relative>

							</Col>
							<Col className="pa3" sm="1" md="1/2" lg="8/16">
							<div className="pt1"></div>
							<Responsive maxWidth={789} ><div className="pt3">&nbsp;</div></Responsive>
							<Collapsible tabIndex={0} open={true} trigger="Produktbeschreibung">
							<p className="pr3 pl3">
							<DescriptionSection product={product}/>
								
								</p>
								</Collapsible>
							<Collapsible tabIndex={0} open={true} trigger="Produktdetails">
							<p className="pr3 pl3">
									{<TechnicalTable  product={product} />}
									</p>
									</Collapsible>
									{product.extras && product.extras.gefahrgut_kuerzel0 && product.extras.gefahrgut_kuerzel0.value && 
										<Collapsible tabIndex={0} open={dangerItem} trigger="Gefahrenhinweise">
									<p className="pr3 pl3">
									<DangerSection className="" poison={poison} 
												acidCorrosion={acidCorrosion} 
												oxidizing={oxidizing}
												flamable={flamable}
												extremeHealthHazard={extremeHealthHazard}
												explosive={explosive}
												gasPressure={gasPressure}
												healthHazard={healthHazard}
												pollution={pollution}
												product={product} />
												</p>
									</Collapsible>}
									{
										<ProductDownloads product={product}/>
									}
							</Col>
						</Row> */}
					</section>
				{/*					<div className="pt3 pt4-ns">
                  <h4>Details</h4>
                  <CustomFields product={product} columns={Object.entries( product.extraValue )
                                                                 .map( ( [key, value] ) => {
                                                                   return key
                                                                 } )
                                                                 .filter( key => key )
                  }/>
                </div> */}

					{!byAttribute && <Loader />}

					{showOrderTable && <Modal style={{paddingTop: "5%", paddingBottom: "2%"}} open size={"fullscreen"}>
						<Modal.Header>
							{product.desc.short_des.split( "," )[0]} 
							<div className="absolute right-1 top-1"><Button basic circular icon="times" onClick={this.toggleModal} /></div>
						</Modal.Header>
						<Modal.Content className={"relative"}>
							<OrderTableContainer isToggle={showOrderTable} product={product} key={product.map_id}/>
							<div className="absolute bottom-1 left-1">
								<Button basic onClick={this.toggleModal}>{translate( "Zurück" )}</Button>
							</div>
						</Modal.Content>
					</Modal>}

					{shop.config.plugin.showVariantsTable && byAttribute && <div className="pb5">
						<section ref={myRef} id="my-section">
						</section>
						<div className={"overflow-hidden cf"}>
							{/*<div className={"f3 fw3 tc pt2 pb4 "}>Jetzt bestellen</div>*/}
							{console.log("byAttribute",byAttribute, product.mainart, variantProtoypeByKey, variantMap)}
							{!Object.keys(variantMap || {}).some(key => key.includes("null")) && byAttribute && product.mainart && <OrderTable style={{zIndex: 120}} product={product} byAttribute={byAttribute}
														variantProtoypeByKey={variantProtoypeByKey}
														variantMap={variantMap} />}
						</div>
					</div>}

					{/* DEBUG */}

				</Container>


				{document.location.search.indexOf( "debug" ) >= 0 && <Container>
					<pre>{JSON.stringify( product, null, 2 )}</pre>
				</Container>}
		
		{additionalProds && additionalProds.length > 0 && <div className="bt bb b--black-10">
          <Container>
            {/*Product Slider "last viewed"*/}
            <section className="section-product-slider pv5">
              <h2 className="mt1  ttu">{translate( "Zubehör" )}</h2>
              <ProductList
                count={4}
                start={0}
                list={additionalProds}
				displayMode={"list"}
                repeat={ProductCard}/>
            </section>
          </Container>
        </div>}
		{/*console.log("additionalCustProds: ",additionalCustProds)*/}
		{additionalCustProds && additionalCustProds.length > 0 &&  <div className="bt bb b--black-10">
          <Container>
            <section className="section-product-slider pv5">
              <h2 className="mt1  ttu">{translate( "Andere Kunden kauften auch" )}</h2>
			  
              <ProductList
                count={4}
                start={0}
                list={additionalCustProds}
				displayMode={"list"}
                repeat={ProductCard}/>
            </section>
          </Container>
        </div>}
			{console.log("lastProducts: ",lastProducts)}
		<div className="bt bb b--black-10">
					<Container>
						{/*Product Slider "last viewed"*/}
						<section className="section-product-slider pv5">
							<h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>
							<Responsive minWidth={790}>
								<ProductList
									count={4}
									start={0}
									list={lastProducts}
									displayMode={"list"}
									repeat={ProductCard}/>
							</Responsive>
							<Responsive maxWidth={789}>
								<ProductList
									count={4}
									start={0}
									list={lastProducts}
									displayMode={"mobile"}
									repeat={ProductCard}/>
							</Responsive>
						</section>
					</Container>
				</div>

        {/*product.category && <div className="pv4">
          <Container>
            <section className="section-product-slider">
              <div className="cf relative pb3">
                {product.category.desc && <Button basic as={Link} to={`/collection/${product.category.getParents().join( "/" )}/${product.category.map_desc_id}/`}><h2
                  className="mt2 ttu">{`${translate( "Andere Kunden kauften auch" )} `} <Icon name="chevron right"/></h2>
                </Button>}
              </div>

              <ProductSearch
                count={4}
                start={0}
                cats={[cat_id]}
                query="%%"
                repeat={ProductCard}/>
            </section>
          </Container>
		</div>*/}


				{/*{product.extras.Kollektion && <div className="bg-silver pv4">*/}
				{/*<Container>*/}
				{/*<section className=" pt3 pb5">*/}

				{/*<div className="cf relative pb3">*/}
				{/*{product.category.desc &&*/}
				{/*<Link to={
    `/collection-extra/Kollektion/${product.extras.Kollektion}`
  }><h2*/}
				{/*className="mt2 ttu">{
    `${translate("Mehr aus Kollektion")}  ${product.extras.Kollektion}`
  } <Icon*/}
				{/*name="chevron right"/></h2>*/}
				{/*</Link>}*/}
				{/*</div>*/}

				{/*<ProductSearchExtra*/}
				{/*count={4}*/}
				{/*start={0}*/}
				{/*extra={"Kollektion"}*/}
				{/*extraValue={product.extras.Kollektion}*/}
				{/*query="%%"*/}
				{/*repeat={ProductCard}/>*/}
				{/*</section>*/}

				{/*</Container>*/}
				{/*</div>}*/}

				{/*{product.category && <div className="pv4">*/}
				{/*<Container>*/}
				{/*<section className="section-product-slider">*/}
				{/*<div className="cf relative pb3">*/}
				{/*{product.category.desc && <Button basic as={Link} to={
    `/collection/${product.category.map_id}`
  }><h2*/}
				{/*className="mt2 ttu">{`${translate("Mehr aus")} ${product.category.desc.des ||*/}
				{/*product.category.desc.short_des}`} <Icon name="chevron right"/></h2>*/}
				{/*</Button>}*/}
				{/*</div>*/}

				{/*<ProductSearch*/}
				{/*count={4}*/}
				{/*start={0}*/}
				{/*cats={[ cat_id ]}*/}
				{/*query="%%"*/}
				{/*repeat={ProductCard}/>*/}
				{/*</section>*/}
				{/*</Container>*/}
				{/*</div>}*/}

				{/*<div className="pv4 bg-silver">*/}
				{/*<Container>*/}
				{/*/!*Product Slider "last viewed"*!/*/}
				{/*<section className="section-product-slider pv5">*/}
				{/*<h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>*/}
				{/*<ProductList*/}
				{/*count={4}*/}
				{/*start={0}*/}
				{/*list={lastProducts}*/}
				{/*repeat={ProductCard}/>*/}
				{/*</section>*/}
				{/*</Container>*/}
				{/*</div>*/}

			</div>
		)
	}
}

ProductPage.propTypes = {
	price: PropTypes.any
}


const ProductVariant = ( {product} ) => {
	return (
		<Card as={Link} to={`/product/${product.map_id}`}>
			<img className="ui image" src={product.img_src_medium} />
			<div>{product.extraValue.Art}</div>
			<div>{product.extraValue.Groesse}</div>
		</Card>
	)
}

const BulkPricing = ( {product} ) => {
	if ( !product.prices || product.prices.length === 1 ) return null
	return (

		<div className="pt4">
			<h4>{translate("Staffelpreise")}</h4>
			<Responsive minWidth={790}>
			<Table style={{border: "none"}}>
				<tbody>
				{product.prices.map( (price, index) => (
					<tr key={price.q}>
						<td className={index !== product.prices.length - 1 ? "bb b--black-70" : ""}>{translate("ab")} {price.q} {product.extras && product.extras && product.extras.pluralVE ? product.extras.pluralVE.value.value : translate(product.quantities[0].des)}</td>
						<td className={index !== product.prices.length - 1 ? "bb b--black-70" : ""}><Price>{price.p}</Price></td>
					</tr>
				) )}
				</tbody>
			</Table>
				</Responsive>
				<Responsive maxWidth={789}>
					<table className="w-100 ba b--black-20 pa2">
						<colgroup>
							<col width="70%"/>
							<col width="30%"/>
						</colgroup>
					<tbody>
				{product.prices.map( (price, index) => (
					<tr className="ba b--black-20  fw7 f5" key={price.q}>
						<td className={`pa3 ${index !== product.prices.length - 1 ? "bb b--black-20" : ""}`}>{translate("ab")} {price.q} {product.extras && product.extras && product.extras.pluralVE ? product.extras.pluralVE.value.value : translate(product.quantities[0].des)}</td>
						<td className={`pa3 ${index !== product.prices.length - 1 ? "bb b--black-20" : ""}`}><Price>{price.p}</Price></td>
					</tr>
				) )}
				</tbody>
					</table>
					</Responsive>

		</div>
	)
}

const Fullscreen = ( {image, change, images} ) => {
	document.body.classList.remove( "no-scroll" )
	if ( !image ) {
		return null
	}
	window.scrollTo( 0, 0 )
	const imgs = _.map( images, ( {img_src_large, img_src_small}, key ) => {
		return (
			<img key={key}
				 alt={""}
				 onClick={() => {
					 change( img_src_large )
				 }}
				 className="img-thumbnail "
				 src={img_src_small} />
		)
	} )

	document.body.classList.add( "no-scroll" )
	return (
		<div className="fullscreen">
			<div className="ui pull-right"
				 style={{position: "relative"}}>
				<Button icon="close"
						basic
						onClick={() => {
							change( false )
						}} />
			</div>

			<div className="center-child"
				 onClick={() => {
					 change( false )
				 }}>
				<div className="zoom-out img-container">
					<img src={image} alt="" />
				</div>
			</div>

			<div className="ui ui-bottom pull-right ">
				<div className="product-images">
					{imgs}
				</div>
			</div>
		</div>
	)
}

Fullscreen.propTypes = {
	children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}

const TechnicalTable = ( {product} ) => {
	const mode = settingStore.get( "orderMode" )
	return (
		<div className="pt4">
			{/*<h2 className="bb pb2  f4 fw6 pb4 productDetailsDiv">Produktdetails</h2>*/}
			<Responsive maxWidth={789}>
					<table className="w-100 pa2 pb4">
						<colgroup>
							<col width="50%"/>
							<col width="50%"/>
						</colgroup>
					<tbody>
					<tr className="bb b--black-20  fw7 f5">
						<td className="pa3">
							<label className={" "}>
							{translate( "Artikel Nr." )}
							</label>
						</td>
						<td className="pa3">
						<b>{product.article_nr}</b>
						</td>
					</tr>	
					{product.barcode && <tr className="bb b--black-20  fw7 f5">
						<td className="pa3">
							<label className={" "}>
							{translate( "EAN" )}
							</label>
						</td>
						<td className="pa3">
						<b>{product.barcode}</b>
						</td>
					</tr>}
					{product.extras && Object.keys( product.extras ).sort()
                                                       .filter( e => e )
                                                       .filter( e => e !== "Zubehör" )
													   .filter( e => !e.startsWith("gefahrgut") )
													   .filter( e => !e.startsWith("attr") )
													   .filter( e => !e.startsWith("Einkaufspreis") )
													   .filter( e => !e.startsWith("Empfehlung") )
													   .filter( e => !e.startsWith("Einlagerung") )
													   .filter( e => !e.startsWith("Kurzbeschreibung") )
													   .filter( e => !e.startsWith("stockText") )
													   .filter( e => !e.startsWith("stockColor") )
													   .filter( e => !e.startsWith("pluralVE") )
													   .filter( e => !e.startsWith("veCount") )
													   .filter( e => !e.startsWith("Lagerbestand") )
													   .filter( e => !e.startsWith("status") )
                                                       .map( columnKey => {
														 //console.log("columnKey: ", columnKey)
                                                         const valueObject = product.extras[ columnKey ]
                                                         if ( !valueObject ) return null
														 if ( !valueObject.value ) return null
														 const value = (valueObject.value.text.startsWith(",") || (valueObject.value.text.split(",").length >= 3)) ? valueObject.value.text.replaceAll(",", ", ") : valueObject.value.text;
														 //console.log("value: ", value)
														 return <React.Fragment key={columnKey}>
														   <tr className="bb b--black-20  fw7 f5">
														   <td className="pa3">{valueObject.text || translate( columnKey )}</td>
															 {value.startsWith(",") &&<td className="pa3"><b>{value.substring(1,value.length-2) || "Kein Wert"}</b></td>}
															 {!value.startsWith(",") && <td className="pa3"><b>{value || "Kein Wert"}</b></td>}
														   </tr>
														 </React.Fragment>
                                                       } )}
				</tbody>
					</table>
					</Responsive>
					<Responsive minWidth={790}>
			<Table basic="very" className="bt  b--black-10 " >
				<Table.Body>


					<Table.Row>
						<Table.Cell>
							<label className={" "}>
								{translate( "Artikel Nr." )}
							</label>
						</Table.Cell>
						<Table.Cell>
							<b>{product.article_nr}</b>
						</Table.Cell>
					</Table.Row>
					{product.barcode && <Table.Row>
						<Table.Cell>
							<label className={" "}>
								{translate( "EAN" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							<b>{product.barcode}</b>
						</Table.Cell>
					</Table.Row>}
					{/*shop.session.handId && <Table.Row>
						<Table.Cell>
							<label className={" "}>
								{translate( "Verfügbarkeit" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							<b>{product.stock}</b>
						</Table.Cell>
					</Table.Row>*/}

					{/*console.log("product.extras: ", product.extras ,Object.keys( product.extras ))*/}
					{product.extras && Object.keys( product.extras ).sort()
                                                       .filter( e => e )
                                                       .filter( e => e !== "Zubehör" )
													   .filter( e => !e.startsWith("gefahrgut") )
													   .filter( e => !e.startsWith("attr") )
													   .filter( e => !e.startsWith("Einkaufspreis") )
													   .filter( e => !e.startsWith("Empfehlung") )
													   .filter( e => !e.startsWith("Einlagerung") )
													   .filter( e => !e.startsWith("Kurzbeschreibung") )
													   .filter( e => !e.startsWith("stockText") )
													   .filter( e => !e.startsWith("stockColor") )
													   .filter( e => !e.startsWith("pluralVE") )
													   .filter( e => !e.startsWith("veCount") )
													   .filter( e => !e.startsWith("Lagerbestand") )
													   .filter( e => !e.startsWith("status") )
                                                       .map( columnKey => {
														 //console.log("columnKey: ", columnKey)
                                                         const valueObject = product.extras[ columnKey ]
                                                         if ( !valueObject ) return null
														 if ( !valueObject.value ) return null
														 const value = (valueObject.value.text.startsWith(",") || (valueObject.value.text.split(",").length >= 3)) ? valueObject.value.text.replaceAll(",", ", ") : valueObject.value.text;
														 //console.log("value: ", value)
														 return <React.Fragment key={columnKey}>
														   <Table.Row >
															 <Table.Cell>{translate(valueObject.text) || translate( columnKey )}</Table.Cell>
															 {value.startsWith(",") &&<Table.Cell><b>{value.substring(1,value.length-2) || "Kein Wert"}</b></Table.Cell>}
															 {!value.startsWith(",") && <Table.Cell><b>{value || "Kein Wert"}</b></Table.Cell>}
														   </Table.Row>
														 </React.Fragment>
                                                       } )}
					{/*<Table.Row>
						<Table.Cell>
							<label className={"fw2 black-60 f5"}>
								{translate( "UVP" )}
							</label>
						</Table.Cell>
						<Table.Cell>
							<Price>{mode == 'MODE_PREORDER' ? product.extraValue.uvp_vororder : product.extraValue.uvp}</Price>
						</Table.Cell>
				</Table.Row>*/}


					{/*<Table.Row>*/}
					{/*<Table.Cell>*/}
					{/*<label className={"fw2 black-60 f5"}>*/}
					{/*Größe*/}
					{/*</label>*/}
					{/*</Table.Cell>*/}
					{/*<Table.Cell>*/}
					{/*{product.extras.groesse}*/}
					{/*</Table.Cell>*/}
					{/*</Table.Row>*/}



				</Table.Body>
			</Table>
			</Responsive>
		</div>
	)
}

TechnicalTable.propTypes = {
	product: PropTypes.object
}

const AdditionalTable = ( {product} ) => {
	return (
		<section className="AdditionalTable">
			<Row>
				<Col sm="1" md="1" className="pb3">
					<div className="technischetabelle">
						<strong>weitere Details</strong>
						<table className="table-technical">
							<tbody>

							{product.barcode && <tr>
								<td>EAN</td>
								<td className="text-right">{product.barcode}</td>
							</tr>}
							</tbody>
						</table>
					</div>
				</Col>
			</Row>
		</section>
	)
}

AdditionalTable.propTypes = {
	product: PropTypes.object
}

const TitleSection = ( {product} ) => (
	<section className="product-title mb0 pb2 bb b--black-10">
    <div className="brand">{product.extras.herst !== "unbekannt" &&
      <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link>}</div>
	  <Responsive minWidth={790}>
		<div className=" fw7 f1-ns b lh-copy">{product.desc.short_des}</div>
	  </Responsive>
	  <Responsive maxWidth={789}>
		<div className=" fw7 f3-ns b lh-copy">{product.desc.short_des}</div>
	  </Responsive>
    
	{product.extras && product.extras.Kurzbeschreibung && <div className="title f4 f5-ns b lh-copy">{product.extras.Kurzbeschreibung.value.value}</div>}
    {/*<div className="title f1 b lh-copy">{product.desc.des}</div>*/}
    <div className="id pt2 pb3 f4 pv2 fw7">{translate("Artikelnummer")}: &nbsp;{product.article_nr || product.article_id}</div>

    {product.extras.statusinfo && <Message>{product.extras.statusinfo}</Message>}
    {product.extras.isnew && <Label color={"blue"}>{translate( "Achtung Neuheit - nur vorbestellbar" )}</Label>}


    {/* Availability*/}
    {/*{shop.config.useAvailability !== false && <Availability product={product} />}*/}
    {/*<Availability product={product}/>*/}

  </section>
)

TitleSection.propTypes = {
	product: PropTypes.object
}

const Availability = ( {product} ) => {
	let notice = product.getNotice()
	return (
		<div className="availability">
			{notice}
		</div>
	)
}

const ActionSection = ( {product, onChange, onAdd} ) => {
	if ( !product.canBeBought ) return null
	const list = shop.orderlist.default
	return (
		<section className="product-actions pt2 pb4">
			<div style={{display: "inline-block "}}>
				<p>
					{product.count * product.unit_multi} {translate( "Stück" )} <Price
					className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>
				<ProductQuantityGroup product={product}
									  list={list}
									  showVE={false}
									  onChange={onChange}
									  onAdd={onAdd}
									  large />
			</div>
		</section>
	)
}

ActionSection.propTypes = {
	product : PropTypes.object,
	onChange: PropTypes.func,
	onAdd   : PropTypes.func,
}

const DescriptionSection = ( {product} ) => (
	<section className="description pv3 lh-copy">
    {product && product.desc  && product.desc.des ? htmr(product.desc.des) : ""}
  </section>
)
DescriptionSection.propTypes = {
	product: PropTypes.object,
}


const DangerSection = ({poison, acidCorrosion, oxidizing, flamable, extremeHealthHazard, explosive, gasPressure, healthHazard, pollution, product} ) => (
	<section className="description pv3 lh-copy">
		<table>
			<colgroup>
				<col width="20%" />
				<col width="80%" />
			</colgroup>
			<tbody>
			<tr>
				<td className="v-top pa2">
					{/*console.log("healthHazard: ", healthHazard)*/}
					{product.extras && Object.keys( product.extras )
                                                       .filter( e => e )
													   .filter( e => !e.startsWith("gefahrgut_kuerzel0") )
													   .filter( e => e.startsWith("gefahrgut_kuerzel") )
                                                       .map( columnKey => {
                                                         const valueObject = product.extras[ columnKey ]
                                                         if ( !valueObject ) return null
														 if ( !valueObject.value ) return null
                                                         const value = valueObject.value.text
														 //console.log("valueObject: ", valueObject.value.value)
														for (let i = 0; i < healthHazard.length; i++) {
															if (valueObject.value.value.includes(healthHazard[i].key)) {
																healthHazard.isShown = true;
															}
														}
														for (let i = 0; i < poison.length; i++) {
															if (valueObject.value.value.includes(poison[i].key)) {
																poison.isShown = true;
															}
														}
														for (let i = 0; i < acidCorrosion.length; i++) {
															if (valueObject.value.value.includes(acidCorrosion[i].key)) {
																acidCorrosion.isShown = true;
															}
														}
														for (let i = 0; i < oxidizing.length; i++) {
															if (valueObject.value.value.includes(oxidizing[i].key)) {
																oxidizing.isShown = true;
															}
														}
														for (let i = 0; i < flamable.length; i++) {
															if (valueObject.value.value.includes(flamable[i].key)) {
																flamable.isShown = true;
															}
														}
														for (let i = 0; i < extremeHealthHazard.length; i++) {
															if (valueObject.value.value.includes(extremeHealthHazard[i].key)) {
																extremeHealthHazard.isShown = true;
															}
														}
														for (let i = 0; i < explosive.length; i++) {
															if (valueObject.value.value.includes(explosive[i].key)) {
																explosive.isShown = true;
															}
														}
														for (let i = 0; i < gasPressure.length; i++) {
															if (valueObject.value.value.includes(gasPressure[i].key)) {
																gasPressure.isShown = true;
															}
														}
														for (let i = 0; i < pollution.length; i++) {
															if (valueObject.value.value.includes(pollution[i].key)) {
																pollution.isShown = true;
															}
														}
                                                       } )}
					{product.extras.gefahrgut_kuerzel0 && product.extras.gefahrgut_kuerzel0.value.value && 
						<Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}}  src={`/image/${product.extras.gefahrgut_kuerzel0.value.value}.jpg`}/>}
					{healthHazard && healthHazard.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}}  src={`/Symbole/exclam_gesundheitsgefahr.gif`}/>}
					{poison && poison.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/skull_giftig.gif`}/>}
					{acidCorrosion && acidCorrosion.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/acid_red_aetzend_korrosiv.gif`}/>}
					{oxidizing && oxidizing.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/rondflam.gif`}/>}
					{flamable && flamable.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/flamme.gif`}/>}
					{extremeHealthHazard && extremeHealthHazard.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/silhouete_ernste_gesundheitsgefahr.gif`}/>}
					{explosive && explosive.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/explos.gif`}/>}
					{gasPressure && gasPressure.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/bottle_gase_unter_druck.gif`}/>}
					{pollution && pollution.isShown && <Image style={{maxHeight: "60px", maxWidth: "60px", paddingBottom: "3px"}} src={`/Symbole/Aquatic-pollut-red.gif`}/>}
				</td>
				<td>
				<table>
				<colgroup>
					<col width="30%" />
					<col width="70%" />
				</colgroup>
				<tbody>
					<tr>
						<td className="pb2 pt2">
						<h2 className="">ACHTUNG</h2>
						</td>
						<td>
							&nbsp;
						</td>
					</tr>
					{ product.extras && product.extras.gefahrgut_kuerzel0 && product.extras.gefahrgut_kuerzel0.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel0.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text0.value.value}
						</td>
					</tr>}
					{ product.extras && product.extras.gefahrgut_kuerzel1 && product.extras.gefahrgut_kuerzel1.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel1.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text1.value.value}
						</td>
						</tr>}
					{ product.extras && product.extras.gefahrgut_kuerzel2 && product.extras.gefahrgut_kuerzel2.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel2.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text2.value.value}
						</td>
						</tr>}
					{ product.extras && product.extras.gefahrgut_kuerzel3 && product.extras.gefahrgut_kuerzel3.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel3.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text3.value.value}
						</td>
						</tr>}
						{ product.extras && product.extras.gefahrgut_kuerzel4 && product.extras.gefahrgut_kuerzel4.value.value !== "" && <tr className="pb3 bb b--black-10">
							<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel4.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text4.value.value}
						</td>
						</tr>}
						{ product.extras && product.extras.gefahrgut_kuerzel5 && product.extras.gefahrgut_kuerzel5.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel5.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text5.value.value}
						</td>
						</tr>}
						{ product.extras && product.extras.gefahrgut_kuerzel6 && product.extras.gefahrgut_kuerzel6.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel6.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text6.value.value}
						</td>
						</tr>}
						{ product.extras && product.extras.gefahrgut_kuerzel7 && product.extras.gefahrgut_kuerzel7.value.value !== "" && <tr className="pb3 bb b--black-10">
							<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel7.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text7.value.value}
						</td>
						</tr>}
						{ product.extras && product.extras.gefahrgut_kuerzel8 && product.extras.gefahrgut_kuerzel8.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel8.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text8.value.value}
						</td>
						</tr>}
						{ product.extras && product.extras.gefahrgut_kuerzel9 && product.extras.gefahrgut_kuerzel9.value.value !== "" && <tr className="pb3 bb b--black-10">
						<td className="pb2 pt2">
							&bull;&nbsp; {product.extras.gefahrgut_kuerzel9.value.value}
						</td>
						<td className="pb2 pt2">
							{product.extras.gefahrgut_text9.value.value}
						</td>
						</tr>}
				</tbody>
			</table>
				</td>
			</tr>
			</tbody>
		</table>

	</section>
)
DangerSection.propTypes = {
	product: PropTypes.object,
}


// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/ProductPage.js